import { UserEditPage } from '@pages/user';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta(
    'Редактирование пользователя',
    'Изменение данных пользователя'
  );
}

export default UserEditPage;
